import { render, staticRenderFns } from "./nutritionRecomme.vue?vue&type=template&id=5c3505fe&scoped=true&"
import script from "./nutritionRecomme.vue?vue&type=script&lang=js&"
export * from "./nutritionRecomme.vue?vue&type=script&lang=js&"
import style0 from "./nutritionRecomme.vue?vue&type=style&index=0&id=5c3505fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3505fe",
  null
  
)

export default component.exports